// extracted by mini-css-extract-plugin
module.exports = {"root":"DragIcon_root__3jVrp"};